import { render, staticRenderFns } from "./VolunteerMatchSummaryNet.vue?vue&type=template&id=5982279e"
import script from "./VolunteerMatchSummaryNet.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchSummaryNet.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchSummaryNet.vue?vue&type=style&index=0&id=5982279e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports